import { FC, PropsWithChildren } from "react";
import clsx from "clsx";
import { Row, RowSize } from "@/components/row";
import { TableRowProps } from "@/components/table-row/types";
import { Divider } from "../divider";
import { NO_VALUE } from "@/constants";
import styles from "./styles.scss";

export const TableRow: FC<PropsWithChildren<TableRowProps>> = ({
  size,
  className,
  label,
  value,
  divided = false,
  mandatory = false,
  valueClassName,
}) => (
  <>
    <Row size={size || RowSize.Small} className={clsx(styles.row, className)}>
      <div className={styles.label}>
        {label}
        {mandatory && <span className={styles.asterix}> *</span>}
      </div>
      <div className={clsx(styles.value, valueClassName)}>
        {value || NO_VALUE}
      </div>
    </Row>
    {divided && (
      <Row size={RowSize.Small}>
        <Divider />
      </Row>
    )}
  </>
);
